<template>
  <div>
    <ul class="heading-ul mt-4 ml-10">
      <li>
        <router-link to="/businessEntity" class="vx-row">
          <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          <h4>{{ $t("entity.label.create_business_entity") }}</h4>
        </router-link>
      </li>
    </ul>
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      stepSize="xs"
      shape="circle"
      finishButtonText="Submit"
      ref="wizard"
    >
      <tab-content
        :title="$t('entity.label.business_entity')"
        :icon="tabIndex > 0 ? 'feather icon-check' : ''"
      >
        <ValidationObserver ref="observerOne">
          <!-- tab 1 content -->
          <vx-card class="form-padding">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.business_entity_opened_on")
                    }}<span class="required">*</span></small
                  >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectDate')"
                    v-model="entity.openingDate"
                    class="mb-2 font-semibold"
                  />
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.business_entity_type")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.business_entity_type')"
                  >
                    <v-select
                      label="name"
                      v-model="entity.officeType"
                      :options="entityTemplate.officeTypes"
                      :reduce="(name) => name.name"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.name
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.business_entity_name')"
                >
                  <vs-input
                    :label="$t('entity.label.business_entity_name')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.name"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.relationship_type")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.relationship_type')"
                  >
                    <v-select
                      label="mCodeValue"
                      v-model="entity.businessType"
                      :options="entityTemplate.businessTypes"
                      :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                      :placeholder="$t('entity.label.SelectSearch')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.mCodeValue
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.parent_business_entity")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.parent_business_entity')"
                  >
                    <v-select
                      label="name"
                      v-model="entity.parentId"
                      :options="parentEntities"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(name) => name.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.name
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full"></div>
            </div>
          </vx-card>
        </ValidationObserver>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content
        :title="$t('entity.label.business_entity_details')"
        :icon="tabIndex > 1 ? 'feather icon-check' : ''"
      >
        <ValidationObserver ref="observerTwo">
          <vx-card class="form-padding">
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="vx-row">
                  <div
                    class="vx-col w-full lg:w-1/4 md:w-1/4 sm:w-full xs:w-full"
                  >
                    <vs-upload
                      id="companyFile"
                      text="Company Logo"
                      limit="1"
                      ref="companyLogo"
                      :show-upload-button="true"
                      class="compose-mail-attachment"
                      @change="changeDocument"
                    />
                    <!-- <vs-upload @image-selected="imageSelected"/> -->
                  </div>
                  <div
                    class="vx-col w-full lg:w-3/4 md:w-3/4 sm:w-full xs:w-full"
                  >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('entity.label.company_reg_no')"
                    >
                      <vs-input
                        :label="$t('entity.label.company_reg_no')"
                        class="w-full mb-2 starlabel"
                        v-model="entity.companyRegNo"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                    <div style="height: 20px"></div>
                    <div class="dropdown-with-label">
                      <small class="date-label"
                        >{{ $t("entity.label.payment_type")
                        }}<span class="required">*</span></small
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="$t('entity.label.payment_type')"
                      >
                        <v-select
                          label="item"
                          v-model="entity.payment"
                          :options="entityTemplate.paymentTypeEnum"
                          :placeholder="$t('entity.label.SelectSearch')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full mb-2"
                        >
                          <template v-slot:option="option">{{
                            option.item
                          }}</template>
                        </v-select>
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required|email"
                  v-slot="{ errors }"
                  :name="$t('entity.label.email')"
                >
                  <vs-input
                    :label="$t('entity.label.email')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.email"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.address_name')"
                >
                  <vs-input
                    :label="$t('entity.label.address_name')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.addressName"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.segment_type")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.segment_type')"
                  >
                    <v-select
                      label="name"
                      v-model="entity.dasType"
                      :options="entityTemplateData.segmentTypes"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(name) => name.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.name
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <vs-input
                  :label="$t('entity.label.district')"
                  class="w-full"
                  readonly
                  value="cityTemplate.district"
                  v-model="entity.district"
                />
                <div style="height: 20px"></div>
                <vs-input
                  :label="$t('entity.label.state')"
                  class="w-full mt-2"
                  readonly
                  value="cityTemplate.state"
                  v-model="entity.state"
                />
                <div style="height: 20px"></div>
                <vs-input
                  :label="$t('entity.label.country')"
                  class="w-full mt-2"
                  readonly
                  value="cityTemplate.country"
                  v-model="entity.country"
                />

                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="zip code"
                >
                  <vs-input
                    :label="$t('entity.label.zip_code')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.zip"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="contact person"
                >
                  <vs-input
                    :label="$t('entity.label.contact_person')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.contactPerson"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required|digits:10"
                  v-slot="{ errors }"
                  :name="$t('entity.label.phone_number')"
                >
                  <vs-input
                    :label="$t('entity.label.phone_number')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.phoneNumber"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.pan_card_no')"
                >
                  <vs-input
                    :label="$t('entity.label.pan_card_no')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.pancardNo"
                    @input="validatePanCard"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0] || panCardError
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.gst_reg_no')"
                >
                  <vs-input
                    :label="$t('entity.label.gst_reg_no')"
                    class="w-full mb-2 starlabel"
                    v-model="entity.gstRegNo"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <div style="height: 20px"></div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.city_area")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.city_area')"
                  >
                    <v-select
                      label="item"
                      v-model="entity.city"
                      :options="entityTemplate.addressData.cityData"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      @input="handlerCityChange"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div style="height: 20px"></div>
                <iframe
                  id="map"
                  width="100%"
                  height="406"
                  style="border: 0"
                  loading="lazy"
                  allowfullscreen
                  referrerpolicy="no-referrer-when-downgrade"
                  :src="`https://www.google.com/maps?q=${entity.city}&output=embed`"
                >
                </iframe>

                <vs-checkbox
                  class="mt-4 font-semibold"
                  v-model="entity.subscriberdues"
                  >{{ $t("entity.label.subscriber_dues") }}</vs-checkbox
                >
                <div style="height: 20px"></div>
                <div class="dropdown-with-label">
                  <small class="date-label mt-5"
                    >{{ $t("entity.label.commission_model")
                    }}<span class="required">*</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.commission_model')"
                  >
                    <v-select
                      label="item"
                      v-model="entity.commisionModel"
                      :options="commissionModalItem"
                      :reduce="(obj) => obj.value"
                      :placeholder="$t('entity.label.SelectSearch')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mt-5 mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.item
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div style="height: 20px"></div>
              </div>
            </div>
          </vx-card>
        </ValidationObserver>
      </tab-content>
      <tab-content
        :title="$t('entity.label.done')"
        :icon="tabIndex > 1 ? 'feather icon-check' : ''"
      >
        <vx-card class="form-padding">
          <div style="height: 20px"></div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <img
                src="@/assets/images/pages/success.png"
                style="width: 400px"
              />
            </div>
          </vs-row>
          <div class="center success-msg">
            {{ $t("entity.label.successfully_created_business_entity") }}
          </div>
          <vs-row justify="center">
            <div style="margin-left: auto; margin-right: auto">
              <vs-button @click="$router.push('/businessEntity')">
                {{ $t("entity.label.go_back_to_business_entity_list") }}
              </vs-button>
            </div></vs-row
          >
        </vx-card>
      </tab-content>
      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left"></div>
        <div class="wizard-footer-right"></div>
        <div class="center">
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex == 0"
            type="border"
            @click="$router.push('/businessEntity')"
            >{{ $t("entity.label.cancel") }}</vs-button
          >
          <vs-button
            class="footerButton-cancel"
            v-if="props.activeTabIndex > 0 && !props.isLastStep"
            @click.native="props.prevTab()"
            type="border"
            >{{ $t("entity.label.previous") }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 0"
            @click.native="validateOne()"
            :style="props.fillButtonStyle"
          >
            {{
              props.isLastStep
                ? $t("entity.label.done")
                : $t("entity.label.next")
            }}</vs-button
          >
          <vs-button
            class="footerButton-next"
            v-if="props.activeTabIndex == 1"
            @click.native="validateTwo()"
            :style="props.fillButtonStyle"
            >{{ $t("entity.label.submit") }}</vs-button
          >
        </div>
      </template>
    </form-wizard>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { concat } from "lodash";
import { setHeader, removeHeader } from "@/http";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";
import _ from "lodash";
import UploadPicture from "@/components/UploadPicture.vue";

const entityEmptyObj = {
  name: "",
  officeType: "",
  parentId: null,
  businessType: "",
  contactPerson: "",
  phoneNumber: "",
  pancardNo: "",
  gstRegNo: "",
  commisionModel: "",
  subscriberdues: false,
  email: "",
  addressName: "",
  city: "",
  state: "",
  country: "",
  district: "",
  zip: "",
  companyRegNo: "",
  payment: "",
  dasType: "",
  clientData: {},
  locale: "en",
  dateFormat: "yyyy-MM-dd HH:mm:ss",
  openingDate: moment().format("YYYY-MM-DD HH:mm:ss"),
};

export default {
  data() {
    return {
      imageData: {},
      panCardError: "",
      warningPopup: false,
      warningText: "",
      message: "Success",
      entity: entityEmptyObj,
      parentEntities: [],
      commissionModalItem: [
        { item: "Postpaid", value: 0 },
        { item: "Prepaid", value: 1 },
      ],
      errorMessage: "",

      tabIndex: 0,
      bulkUploads: {
        file: null,
      },
    };
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
    UploadPicture,
  },
  computed: {
    ...mapState({
      entityTemplateData: (state) => state.entity.template,
      cityTemplateData: (state) => state.entity.cityTemplate,
      entityPostResponse: (state) => state.entity.createEntityResponse,
    }),
    entityTemplate() {
      return this.$store.getters["entity/template"];
    },
    cityTemplates() {
      return this.$store.getters["entity/getCityTemplate"];
    },
  },
  methods: {
    async imageSelected(fileData) {
      const data = fileData;
      this.imageData = data;
      try {
        let formData = new FormData();
        formData.append("clientId", this.resourceId);
        formData.append("file", this.imageData);
        setHeader("Content-Type", "multipart/form-data");
        let payload = {
          clientId: this.resourceId,
          formData: formData,
        };
        await this.$store.dispatch("entity/uploadCompanyLogoAction", payload);
        removeHeader("Content-Type");
        this.imageData = {};
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    validatePanCard() {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      const panCard = this.entity.pancardNo;

      if (!panRegex.test(panCard)) {
        this.panCardError = "Invalid PAN Card format (e.g., ABCDE1234F).";
      } else {
        this.panCardError = "";
      }
    },
    changeDocument() {
      // this.profileUrl = this.$refs.docFile.files[0]
      this.bulkUploads.file = document.getElementById("companyFile").files[0];
    },
    async validateOne() {
      const isValid = await this.$refs.observerOne.validate();
      if (!isValid) return;

      this.nextTab();
    },
    async validateTwo() {
      const isValid = await this.$refs.observerTwo.validate();
      if (!isValid) return;

      this.createEntity();
    },
    nextTab() {
      this.tabIndex = this.$refs.wizard.activeTabIndex + 1;

      this.$refs.wizard.nextTab();
    },
    async getTemplate() {
      try {
        this.$store.dispatch("entity/setTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCityTemplate() {
      try {
        await this.$store.dispatch("entity/setCityTemplate", this.entity.city);

        this.entity.district = this.cityTemplateData.district;
        this.entity.state = this.cityTemplateData.state;
        this.entity.country = this.cityTemplateData.country;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createEntity() {
      this.entity.openingDate = moment(this.entity.openingDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const primaryAddress = {
        addressNo: this.entity.addressName,
        city: this.entity.city,
        state: this.entity.state,
        country: this.entity.country,
        district: this.entity.district,
        zipCode: this.entity.zip,
        addressType: "PRIMARY",
      };
      const billingAddress = {
        addressNo: this.entity.addressName,
        city: this.entity.city,
        state: this.entity.state,
        country: this.entity.country,
        district: this.entity.district,
        zipCode: this.entity.zip,
        addressType: "BILLING",
      };
      const addressArray = [primaryAddress, billingAddress];
      const clientData = {
        entryType: "IND",
        clientCategory: 20,
        officeId: this.entity.parentId,
        title: "Mr",
        lastname: ".",
        firstname: this.entity.contactPerson,
        phone: this.entity.phoneNumber,
        email: this.entity.email,
        idKey: 260,
        externalId: "",
        billMode: "Both",
        idValue: "00000",
        locale: "en",
        active: true,
        dateFormat: "yyyy-MM-dd HH:mm:ss",
        activationDate: this.entity.openingDate,
        flag: false,
        nationalityId: 103,
        gender: 1,
        address: addressArray,
      };
      this.entity.clientData = clientData;
      try {
        await this.$store.dispatch("entity/createEntityAction", this.entity);

        let formData = new FormData();

        formData.append("file", this.bulkUploads.file);
        if (this.entityPostResponse.officeId) {
          if (this.bulkUploads.file != null) {
            formData.append(
              "childEntityId",
              this.entityPostResponse.resourceId
            );
            formData.append("name", this.bulkUploads.file.name);
            let payload = {
              id: this.entityPostResponse.resourceId,
              formData: formData,
            };
            await this.$store.dispatch(
              "entity/uploadCompanyLogoAction",
              payload
            );
          }
          // this.imageSelected(this.imageData);
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Business Entity Created Successfully!",
            type: "success",
          });
          this.nextTab();
          this.resetForm();
        }
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    resetForm() {
      this.entity = entityEmptyObj;
    },
    handlerCityChange() {
      this.getCityTemplate();
    },
  },
  watch: {
    "entity.officeType": function (newValue) {
      this.parentEntities =
        _.filter(this.entityTemplate.allowedParents, {
          officeType: newValue,
        }) || [];
    },
    warningPopup(val) {
      if (!val) {
        this.warningText = "";
        this.errorMessage = "";
      }
    },
  },
  mounted() {
    this.getTemplate();
    this.entity = {
      name: "",
      officeType: "",
      parentId: null,
      businessType: "",
      contactPerson: "",
      phoneNumber: "",
      pancardNo: "",
      gstRegNo: "",
      commisionModel: "",
      subscriberdues: false,
      email: "",
      addressName: "",
      city: "",
      state: "",
      country: "",
      district: "",
      zip: "",
      companyRegNo: "",
      payment: "",
      dasType: "",
      clientData: {},
      locale: "en",
      dateFormat: "yyyy-MM-dd HH:mm:ss",
      openingDate: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
    // this.entity.externalId =
    //   this.entity.officeType + Math.floor(Math.random() * 1000000000);
  },
};
</script>
<style>
.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  width: 42%;
  left: 45px;
}
</style>
